<template>
  <div>
    <el-container>
      <el-header>
        <div>
          <router-link to="/index">
            <img class="icon" :src="logoUlr" />
          </router-link>
        </div>
		<div>
			<router-link to='/detail?id=' class="jixuxiadan">继续下单</router-link>
		</div>
        <div class="money">
          当前余额：
          <span>{{yue + '元'}}</span>
        </div>
        <div>
          <router-link to="/recharge" class="payBtn">充值余额</router-link>
          <router-link to="/index">
            <img src="../assets/user/shopping.png" />
          </router-link>
          <router-link to="/systemnew">
            <img src="../assets/user/info.png" />
          </router-link>
          <img style="width:40px;border-radius:50%;" class="toux" :src="avatar" />
        </div>
      </el-header>
      <el-container>
        <el-aside width="200px">
          <el-menu
            :default-active="routeActive"
            class="el-menu-vertical-demo"
            :collapse="isCollapse"
            background-color="#fff"
            active-text-color="#a77c5a"
            :unique-opened="true"
            router
          >
            <el-menu-item index="/backshouye">
              <i class="el-icon-s-home"></i>会员概览
            </el-menu-item>
            <el-submenu index="2">
              <template slot="title">
                <i class="el-icon-goods"></i>
                <span slot="title">快速下单</span>
              </template>
              <el-menu-item-group>
                <el-menu-item index="/batchorder">批量下单</el-menu-item>
                <el-menu-item index="/outgotingOrder">外发待处理</el-menu-item>
              <template v-if="is_server" >
                <el-menu-item>
                  <a :href="url+'/index/custorder'" target="_blank">自定义下单</a>
                </el-menu-item>
                <el-menu-item index="/daikeOrder">代客下单</el-menu-item>
              </template>
              </el-menu-item-group>
            </el-submenu>
            <el-submenu index="3">
              <template slot="title">
                <i class="el-icon-document-copy"></i>
                <span slot="title">订单中心</span>
              </template>
              <el-menu-item-group>
                <el-menu-item index="/order">订单管理</el-menu-item>
                <template v-if="is_server" >
                <el-menu-item index="/orderD">代客下单</el-menu-item>
              </template>
                <el-menu-item index="/fileList">文件替换</el-menu-item>
                <el-menu-item index="/backorder">售后记录</el-menu-item>
                <el-menu-item index="/orderRecyling">已取消的订单</el-menu-item>
              </el-menu-item-group>
            </el-submenu>
            <el-submenu index="4">
              <template slot="title">
                <i class="el-icon-coin"></i>
                <span slot="title">资产中心</span>
              </template>
              <el-menu-item-group>
                <el-menu-item index="/recharge">我要充值</el-menu-item>
                 <el-menu-item index="/rechargelog">充值记录</el-menu-item>
                <el-menu-item index="/consume">消费明细</el-menu-item>
                <el-menu-item index="/reportform">余额流水</el-menu-item>
                <el-menu-item index="/orderform">订单统计</el-menu-item>
                <!-- <el-menu-item index="/recharge">我的优惠券</el-menu-item>
                <el-menu-item index="/recharge">发票管理</el-menu-item>
                <el-menu-item index="/recharge">积分管理</el-menu-item>-->
              </el-menu-item-group>
            </el-submenu>
            <el-submenu index="5">
              <template slot="title">
                <i class="el-icon-coin"></i>
                <span slot="title">财务中心</span>
              </template>
              <el-menu-item-group>
                <el-menu-item index="/usermoney">余额流水</el-menu-item>
                 <el-menu-item index="/billrechange">充值报表</el-menu-item>
                <el-menu-item index="/water">流水报表</el-menu-item>
                <el-menu-item index="/billindex">消费报表</el-menu-item>
                <el-menu-item index="/aftersale">售后退款</el-menu-item>
                <el-menu-item index="/quxiaorechange">取消退款</el-menu-item>
                <el-menu-item index="/third">第三方流水</el-menu-item>
                <el-menu-item index="/monthlyreport">消费月报</el-menu-item>
              </el-menu-item-group>
            </el-submenu>
            <el-submenu index="6">
              <template slot="title">
                <i class="el-icon-upload"></i>
                <span slot="title">我的云盘</span>
              </template>
              <el-menu-item-group>
                <el-menu-item index="/YunPan">文件</el-menu-item>
              </el-menu-item-group>
            </el-submenu>
            <el-submenu index="7">
              <template slot="title">
                <i class="el-icon-user"></i>
                <span slot="title">个人中心</span>
              </template>
              <el-menu-item-group>
                <el-menu-item index="/userinfo">个人信息</el-menu-item>
                <!-- <el-menu-item index="/recharge">修改密码</el-menu-item> -->
                <el-menu-item index="/fahuoaddress">发货地址管理</el-menu-item>
                <el-menu-item index="/address">收货地址管理</el-menu-item>
                <!-- <el-menu-item index="/safety">账户安全</el-menu-item> -->
              </el-menu-item-group>
            </el-submenu>
            <!-- <el-submenu index="7">
              <template slot="title">
                <i class="el-icon-chat-dot-square"></i>
                <span slot="title">消息中心</span>
              </template>
              <el-menu-item-group>
                <el-menu-item index="/systemnew">系统消息</el-menu-item>
              </el-menu-item-group>
              <el-menu-item-group>
                <el-menu-item index="/orderreminder">订单提醒</el-menu-item>
              </el-menu-item-group>
              <el-menu-item-group>
                <el-menu-item index="/promotions">促销活动</el-menu-item>
              </el-menu-item-group>
            </el-submenu>-->
          </el-menu>
        </el-aside>
        <el-container>
          <el-main>
            <router-view></router-view>
          </el-main>
        </el-container>
      </el-container>
    </el-container>
    <Product></Product>
  </div>
</template>

<script>
import Product from '../components/common/hotProduct'

export default {
  components: {
    Product
  },
  data() {
    return {
      isCollapse: false,
      avatar: '',
      yue: '',
      routeActive: '',
      logoUlr: '',
      is_server: 0,
      url: ''
    }
  },
  created() {
    const baseUlr = window.location.host
    this.url = !baseUlr.includes('192')
      ? 'https://' + baseUlr
      : 'https://www.yunshanyin.net'
      console.log(this.url)
    if (window.localStorage.getItem('u')) {
      let u = window.localStorage.getItem('u')
      this.avatar = JSON.parse(u).avatar
      this.getYue()
    }
    this.queryInfo()
    this.mineInfo()
  },
  methods: {
    async queryInfo() {
      const { data: res } = await this.$http.get('/api/index/apidata')
      this.logoUlr = res.data.logo
      let sy_info = {
        logo: res.data.logo,
        beian: res.data.beian
      }
      window.sessionStorage.setItem('sy_info', JSON.stringify(sy_info))
    },
    // 用户余额
    async getYue() {
      let param = new URLSearchParams()
      param.append('token', window.localStorage.getItem('token'))
      const { data: res } = await this.$http({
        method: 'post',
        url: 'api/mine/index',
        data: param
      })
      this.yue = res.data.money
    },
     // 用户余额
    async mineInfo() {
      let param = new URLSearchParams()
      param.append('token', window.localStorage.getItem('token'))
      const { data: res } = await this.$http({
        method: 'post',
        url: 'api/mine/index',
        data: param
      })
      this.is_server = res.data.is_server
      console.log(this.is_server)
    }
  },
  mounted() {},
  watch: {
    $route(to, from) {
      this.routeActive = to.path
    }
  }
}
</script>

<style lang="less" scoped>
.container {
  width: 100%;
  height: 100%;
}
.money {
  position: absolute;
  top: 20px;
  right: 255px;
  font-size: 20px;
  span {
    color: #e83030;
  }
}
.payBtn {
  padding: 3px 5px;
  background-color: #a77c5a;
  border-radius: 5px;
  font-size: 12px;
  color: #fff;
}
.el-header {
  width: 100%;
  background: #fff;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .icon {
    height: 60px;
    margin-left: 0;
  }
  div {
    display: flex;
    align-items: center;
    img {
      margin-left: 15px;
    }
    .toux {
      margin-right: 30px;
    }
  }
}
.el-aside {
  min-height: 875px;
  background: #fff;
  overflow-x: hidden;
  li:focus,
  li:hover {
    background: rgb(250, 247, 244) !important;
  }
  .el-menu-vertical-demo:not(.el-menu--collapse) {
    width: 200px;
    min-height: 400px;
  }
}
.el-main {
  padding: 60px 50px 0 50px;
  background-color: #eee;
}
.jixuxiadan{
	background: #a67a59;
	  padding: 10px;
	  font-size: 18px;
	  color: white;
	  border-radius: 5px;
}
</style>
